import { custom, success } from "./utilities";
import { companyConstants, globalConstants } from "../../constants";
import { companyService } from "../../services/company.services";
import { ToastifyService } from "../../services/toastify.services";

const gridData = {
  length: 10,
  pageNumber: 1,
  orderBy: "",
  filterQuery: null,
  search: null,
  filterExpression: globalConstants.FILTER_EXPRESSION
};

export const getAllCompanies = (gridState) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    companyService
      .getAll(gridState)
      .then((response) => {
        dispatch(success(response, companyConstants.GET_COMPANY));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const getCompanyById = (id) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    companyService
      .getById(id)
      .then((response) => {
        console.log("response", response);
        dispatch(success(response, companyConstants.GET_COMPANY_BY_ID));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const deleteCompanyById = (id) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    companyService
      .deleteById(id)
      .then((response) => {
        dispatch(getAllCompanies(gridData));
        ToastifyService.showSuccess("Status Updated Successfully");
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const createCompany = (data) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    companyService
      .create(data)
      .then((response) => {
        dispatch(getAllCompanies(gridData));
        ToastifyService.showSuccess(response.items);
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const updateCompany = (data) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    companyService
      .update(data)
      .then((response) => {
        dispatch(getAllCompanies(gridData));
        ToastifyService.showSuccess(response);
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const getAllCompanyList = () => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    companyService
      .getAllList()
      .then((response) => {
        dispatch(success(response, companyConstants.GET_COMPANY_LIST));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const getAllPlatformCompanies = (gridState) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    companyService
      .getAllPlatformCompanies(gridState)
      .then((response) => {
        dispatch(success(response, companyConstants.GET_COMPANY));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const updatePlatformCompany = (data) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    companyService
      .updatePlatformCompany(data)
      .then((response) => {
        dispatch(getAllPlatformCompanies(gridData));
        ToastifyService.showSuccess(response);
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const getPlatformCompanyById = (id) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    companyService
      .getPlatformCompanyById(id)
      .then((response) => {
        console.log("response", response);
        dispatch(success(response, companyConstants.GET_COMPANY_BY_ID));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const deletePlatformCompanyById = (id) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    companyService
      .deletePlatformCompanyById(id)
      .then((response) => {
        dispatch(getAllPlatformCompanies(gridData));
        ToastifyService.showSuccess("Status Updated Successfully");
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const companyActions = {
  getAllCompanies,
  getCompanyById,
  deleteCompanyById,
  createCompany,
  updateCompany,
  getAllCompanyList,
  getAllPlatformCompanies,
  updatePlatformCompany,
  getPlatformCompanyById,
  deletePlatformCompanyById
};
